module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    class: ['pane-section', _vm.collapsed ? 'collapsed' : '']
  }, [_c('section', {
    staticClass: "pane-section__header"
  }, [_c('section', {
    staticClass: "pane-section--left",
    on: {
      "click": function($event) {
        _vm.collapsed = !_vm.collapsed
      }
    }
  }, [_c('button', {
    staticClass: "pane-section--icon"
  }, [_c('ui-icon', {
    attrs: {
      "name": _vm.collapsed ? 'chevron-down' : 'chevron-up'
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "pane-section--title"
  }, [_vm._t("title", [_vm._v(_vm._s(_vm.title))], {
    tag: "span"
  })], 2)]), _vm._v(" "), _c('section', {
    staticClass: "pane-section--right"
  }, [_c('div', {
    staticClass: "hidden-when-collapsed"
  }, [_vm._t("pane-header-right"), _vm._v(" "), (typeof _vm.hasButton === 'undefined' || _vm.hasButton === true) ? _c('ui-button', {
    attrs: {
      "title": "View all"
    },
    on: {
      "click": _vm.onViewAll
    }
  }) : _vm._e()], 2)])]), _vm._v(" "), _c('section', {
    class: ['pane-section__content', _vm.hasSlot ? 'has-slot' : '']
  }, [_vm._t("default", [_c('ui-data-list', {
    attrs: {
      "header": _vm.tableHeader,
      "preset": _vm.preset,
      "type": "pane",
      "tools": _vm.tools,
      "itemCount": _vm.itemCount,
      "maxItems": _vm.itemCountMax,
      "minItems": _vm.itemCountMin,
      "cache": false,
      "includeInList": _vm.includeInList
    }
  })])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75106f2c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/universal/PaneSection.vue
// module id = 457
// module chunks = 1